const STROKE = "#1A1410";
const PAPER = "#FBEFD9";

function StickerFrame({ bg, children }) {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" style={{ display: "block" }}>
      <defs>
        <filter id="sticker-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow
            dx="0"
            dy="2"
            stdDeviation="0"
            floodColor={STROKE}
            floodOpacity="1"
          />
        </filter>
      </defs>
      <g filter="url(#sticker-shadow)">
        <rect
          x="3"
          y="3"
          width="58"
          height="58"
          rx="14"
          fill={bg}
          stroke={STROKE}
          strokeWidth="3"
        />
        <g
          stroke={STROKE}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        >
          {children}
        </g>
      </g>
    </svg>
  );
}

function YouTubeIcon() {
  return (
    <StickerFrame bg="#F2A9A0">
      <rect x="13" y="20" width="38" height="26" rx="4" fill={PAPER} />
      <path d="M28 28 L28 38 L38 33 Z" fill={STROKE} stroke="none" />
      <line x1="20" y1="50" x2="26" y2="46" />
      <line x1="44" y1="50" x2="38" y2="46" />
      <circle cx="48" cy="17" r="1.5" fill={STROKE} stroke="none" />
    </StickerFrame>
  );
}

function FacebookIcon() {
  return (
    <StickerFrame bg="#A9C4E8">
      <path
        d="M14 16 Q14 12 18 12 L46 12 Q50 12 50 16 L50 36 Q50 40 46 40 L28 40 L20 48 L22 40 L18 40 Q14 40 14 36 Z"
        fill={PAPER}
      />
      <path d="M34 20 Q34 18 36 18 L40 18 M36 18 L36 36 M30 26 L40 26" />
    </StickerFrame>
  );
}

function PinterestIcon() {
  return (
    <StickerFrame bg="#E8A0A8">
      <path
        d="M32 12 L32 18 L26 26 L26 36 L38 36 L38 26 L32 18"
        fill={PAPER}
      />
      <line x1="32" y1="36" x2="32" y2="52" />
      <ellipse cx="32" cy="22" rx="4" ry="2" fill={STROKE} stroke="none" />
    </StickerFrame>
  );
}

function InstagramIcon() {
  return (
    <StickerFrame bg="#E8C8A0">
      <rect x="12" y="20" width="40" height="28" rx="3" fill={PAPER} />
      <rect x="22" y="14" width="14" height="8" rx="1" fill={PAPER} />
      <circle cx="32" cy="34" r="7" fill="#F2A9A0" />
      <circle cx="32" cy="34" r="3.5" fill={PAPER} />
      <circle cx="44" cy="26" r="1.5" fill={STROKE} stroke="none" />
    </StickerFrame>
  );
}

const ICONS = {
  youtube: YouTubeIcon,
  facebook: FacebookIcon,
  pinterest: PinterestIcon,
  instagram: InstagramIcon,
};

export function SocialIcon({ name, size = 36, className = "" }) {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return (
    <span
      className={className}
      style={{ width: size, height: size, display: "inline-block" }}
    >
      <Icon />
    </span>
  );
}

export const SOCIAL = [
  { key: "youtube",   label: "YouTube",   handle: "@Caffei_N",  href: "https://www.youtube.com/@Caffei_N" },
  { key: "facebook",  label: "Facebook",  handle: "caffeiN0w0", href: "https://facebook.com/caffeiN0w0" },
  { key: "pinterest", label: "Pinterest", handle: "caffei_n",   href: "https://www.pinterest.com/caffei_n" },
  { key: "instagram", label: "Instagram", handle: "caffei_n_",  href: "https://www.instagram.com/caffei_n_" },
];

/* Flat brand icons — used on the About Me page with handle text */

function SimpleYouTube() {
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
      <path d="M23 7s-.3-1.9-1.2-2.7c-1.1-1.2-2.4-1.2-3-1.3C16.1 3 12 3 12 3s-4.1 0-6.8.2c-.6.1-1.9.1-3 1.3C1.3 5.3 1 7 1 7S.7 9.1.7 11.2v1.9C.7 15.2 1 17 1 17s.3 1.9 1.2 2.7c1.1 1.2 2.6 1.1 3.3 1.2C7.6 21 12 21 12 21s4.1 0 6.8-.2c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.7 1.2-2.7s.3-2.1.3-4.2v-1.9C23.3 9.1 23 7 23 7zM9.7 15.5v-7l8.1 3.5-8.1 3.5z" />
    </svg>
  );
}

function SimpleFacebook() {
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
      <path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.41 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.88v2.27h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z" />
    </svg>
  );
}

function SimplePinterest() {
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.08 3.16 9.44 7.63 11.2-.1-.96-.2-2.44.04-3.49.22-.95 1.47-6.22 1.47-6.22s-.37-.75-.37-1.86c0-1.75 1.01-3.06 2.27-3.06 1.07 0 1.59.81 1.59 1.77 0 1.08-.69 2.69-1.04 4.18-.3 1.25.62 2.26 1.84 2.26 2.2 0 3.9-2.32 3.9-5.67 0-2.97-2.13-5.04-5.17-5.04-3.52 0-5.59 2.64-5.59 5.37 0 1.06.41 2.2.92 2.82.1.12.11.23.08.35-.09.38-.3 1.25-.34 1.43-.05.23-.18.28-.4.17-1.5-.7-2.43-2.88-2.43-4.63 0-3.77 2.74-7.23 7.9-7.23 4.14 0 7.36 2.95 7.36 6.9 0 4.11-2.59 7.42-6.19 7.42-1.21 0-2.35-.63-2.74-1.37l-.74 2.78c-.27 1.04-1 2.34-1.49 3.13.56.17 1.15.26 1.76.26 6.63 0 12-5.37 12-12S18.63 0 12 0z" />
    </svg>
  );
}

function SimpleInstagram() {
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
}

const SIMPLE_ICONS = {
  youtube: SimpleYouTube,
  facebook: SimpleFacebook,
  pinterest: SimplePinterest,
  instagram: SimpleInstagram,
};

export function SimpleIcon({ name, size = 20, className = "" }) {
  const Icon = SIMPLE_ICONS[name];
  if (!Icon) return null;
  return (
    <span
      className={className}
      style={{ width: size, height: size, display: "inline-block", flexShrink: 0 }}
    >
      <Icon />
    </span>
  );
}
